import {
   ReportRowSeverityAliases,
   ReportRowSeverityLevel
} from '../models/report-row-severity';

const DEFAULT_ROW_SEVERITY_ALIASES: ReportRowSeverityAliases = {
   critical: 'critical',
   severe: 'critical',
   danger: 'critical',

   high: 'high',
   risky: 'high',
   risk: 'high',

   medium: 'medium',
   med: 'medium',
   warning: 'medium',
   careful: 'medium',
   caution: 'medium',

   low: 'low',
   minor: 'low',

   info: 'info',
   informational: 'info',

   safe: 'success',
   success: 'success',
   ok: 'success',
   clear: 'success',

   none: 'none',
   no: 'none',
   false: 'none',
   '': 'none'
};

function normaliseSeverityKey(value: unknown): string {
   if (value === null || value === undefined) return '';

   return String(value).trim().toLowerCase();
}

export function normaliseReportRowSeverity(
   value: unknown,
   aliases?: ReportRowSeverityAliases
): ReportRowSeverityLevel {
   const key = normaliseSeverityKey(value);

   const mergedAliases = {
      ...DEFAULT_ROW_SEVERITY_ALIASES,
      ...(aliases ?? {})
   };

   return mergedAliases[key] ?? 'none';
}
